/**
 * Reusable Year Options Helper & Component
 */

/**
 * Returns an array of year numbers from startYear (default 1947) to endYear (default current year).
 * @param {number} startYear 
 * @param {number} endYear 
 * @returns {number[]}
 */
export const getYearList = (startYear = 1947, endYear = new Date().getFullYear()) => {
  const years = [];
  for (let i = startYear; i <= endYear; i++) {
    years.push(i);
  }
  return years;
};

/**
 * Returns an array of <option> JSX elements from startYear to endYear.
 * @param {number} startYear 
 * @param {number} endYear 
 * @returns {JSX.Element[]}
 */
export const getYearSelectOptions = (startYear = 1947, endYear = new Date().getFullYear()) => {
  return getYearList(startYear, endYear).map((year) => (
    <option key={year} value={year}>
      {year}
    </option>
  ));
};

export const Yearofbirthoption = getYearList;
export const Years = getYearList;

export default getYearList;
